export type State = {
  queue: Map<string, number>;
  queueHead: string | undefined | null;
};

export const initialState: State = {
  queue: new Map(),
  queueHead: null,
};

function computeQueueHead(queue: Map<string, number>): string | undefined | null {
  if (queue.size === 0) {
    return null;
  }

  if (queue.size === 1) {
    return queue.keys().next().value;
  }

  // $FlowIssue
  return Array.from(queue).sort((a, b) => a[1] - b[1])[0][0];
}

export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'banners/ENQUEUE':
      state.queue.set(action.bannerName, action.priority);
      return { ...state, queue: state.queue, queueHead: computeQueueHead(state.queue) };
    case 'banners/DEQUEUE':
      state.queue.delete(action.bannerName);
      return { ...state, queue: state.queue, queueHead: computeQueueHead(state.queue) };
    default:
      return state;
  }
}

type enqueueAction = {
  type: 'banners/ENQUEUE';
  bannerName: string;
  priority: number;
};

export function enqueue(bannerName: string, priority: number): enqueueAction {
  return {
    type: 'banners/ENQUEUE',
    bannerName,
    priority,
  };
}

type dequeueAction = {
  type: 'banners/DEQUEUE';
  bannerName: string;
};

export function dequeue(bannerName: string): dequeueAction {
  return {
    type: 'banners/DEQUEUE',
    bannerName,
  };
}

export type BannersActions = enqueueAction | dequeueAction;
